export default "__VITE_ASSET__CzOj7K8D__"